// Rummy waiting overlay — shown while the queue fills.

import { useEffect, useState } from 'react';

type Profile = { userId?: string; name?: string; avatarUrl?: string | null; is_bot?: boolean };

export default function WaitingModal({
  current, required, bet, players, botActivateAt, profiles, yourUserId, onCancel,
}: {
  current: number;
  required: number;
  bet: number;
  players: number;
  botActivateAt: number | null;
  profiles: Profile[];
  yourUserId: string | null;
  onCancel: () => void;
}) {
  const [countdown, setCountdown] = useState<number | null>(null);
  useEffect(() => {
    if (!botActivateAt) { setCountdown(null); return; }
    const tick = () => {
      const left = Math.max(0, Math.ceil((botActivateAt - Date.now()) / 1000));
      setCountdown(left);
    };
    tick();
    const t = window.setInterval(tick, 250);
    return () => clearInterval(t);
  }, [botActivateAt]);

  const slots = Array.from({ length: required }).map((_, i) => profiles[i] || null);

  return (
    <div className="rummy-modal-backdrop">
      <div className="rummy-modal" style={{ minWidth: 360 }}>
        <h2>Finding Players…</h2>
        <p>Bet {bet.toLocaleString('en-IN')} · {players} seats</p>

        <div className="flex justify-center gap-2 mb-4">
          {slots.map((p, i) => (
            <div key={i} className="flex flex-col items-center" style={{ width: 64 }}>
              <div className="w-12 h-12 rounded-full border-2 border-[#fde08b]/60 overflow-hidden grid place-items-center bg-black/50">
                {p?.avatarUrl
                  ? <img src={p.avatarUrl} alt="" className="w-full h-full object-cover" />
                  : <span className="text-[11px] text-[#fde08b]/70 font-bold">{p?.name ? p.name.slice(0, 1).toUpperCase() : '…'}</span>}
              </div>
              <div className="mt-1 text-[9px] text-neutral-200 truncate max-w-full">
                {p ? (p.userId === yourUserId ? 'YOU' : p.name || 'Player') : 'Waiting'}
              </div>
            </div>
          ))}
        </div>

        <p className="text-[11px] text-neutral-400">
          {current} of {required} players joined
          {/* Original copy was "bots arrive in Ns" which leaked the
              fact that a bot would fill the seat. Renamed to a
              neutral countdown — same trigger (server's
              bot_activate_at timestamp) so the timing is precise. */}
          {countdown != null && <> · match starts in <b>{countdown}s</b></>}
        </p>

        <div className="flex justify-center gap-3 mt-4">
          <button
            className="px-5 py-2 rounded-full bg-red-600 hover:bg-red-700 text-white font-bold text-sm"
            onClick={onCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
